export const isApiGatewayUrl = url => ['/gateway/api'].includes(url);